<template>
  <div>
    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    </div>

    <v-menu
      transition="scale-transition"
      offset-overflow
      nudge-bottom="30"
      nudge-right="20"
      min-width="200"
      max-width="200"
      class="userblock-dropdown"
      light
    >
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          small
          v-on="on"
          color="accent"
          placement="bottom"
          :title="data.Account_Tooltip_Label"
        >
          <v-icon dark>person</v-icon>
        </v-btn>
      </template>
      <v-list class="user-dropdown-list">
        <v-list-item v-if="userData.name">
          <a href="/account/profile">
            <v-icon class="mr-2">account_circle</v-icon>
            <span>{{userData.name}}</span>
          </a>
        </v-list-item>
        <v-list-item v-if="userData.name">
          <a @click.prevent="logout()" href="#">
            <v-icon class="mr-2">exit_to_app</v-icon>
            <span>{{data.Log_Out_Label}}</span>
          </a>
        </v-list-item>
        <v-list-item v-else>
          <a
            href="https://ecom.auth.ap-south-1.amazoncognito.com/login?client_id=6tiuv4k2usal6rgson7mhu8a53&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone&redirect_uri=https://ecomdemo.sgspartnerworld.com?nodeCode=AGY20518"
          >
            <v-icon class="mr-2">power_settings_new</v-icon>
            <span>{{data.Login_Label}}</span>
          </a>
        </v-list-item>

        <!-- <v-list-item v-for="(userLink, key) in data.Profile_List" :key="key">
          <a :href="userLink.Profile_Path">
            <v-icon class="mr-2">{{userLink.Profile_Icon}}</v-icon>
            <span>{{userLink.Profile_Title}}</span>
          </a>
        </v-list-item>-->
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import gettingHttpFunctions from "../../../../services/utils/http-helper";
import gettingRestClientObject from "../../../../services/utils/cms-helper";
import Nprogress from "nprogress";
import "nprogress/nprogress.css";
import { mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  props: ["data"],
  computed: {
    ...mapGetters(["products"]),
  },
  data() {
    return {
      userData: {},
      // isLoading: false,
    };
  },
  components: {
    Loading,
  },
  created() {
    this.login();
    this.checkLogin();
  },
  methods: {
    async login() {
      var self = this;
      self.isLoading = true;
      // Nprogress.start();
      let httpRequestFunctions = gettingHttpFunctions();
      var parameters = self.$route.query;
      if (parameters.code && parameters.nodeCode) {
        if (parameters.code !== localStorage.code) {
          localStorage.setItem("code", parameters.code);
          localStorage.setItem("nodeCode", parameters.nodeCode);
          var postData = { hqCode: parameters.nodeCode, code: parameters.code };
          var config = {
            axiosConfig: {
              method: "POST",
              url: "token",
              data: postData,
              isBarrerNeeded: false,
            },
          };
          var resp = await httpRequestFunctions.mainAxiosRequest(config);
          if (resp !== undefined) {
            localStorage.setItem("embryo", JSON.stringify({ user_data: resp }));
            self.isLogin = true;
            self.userDetail = resp;
            self.$store.dispatch("destroyCartAndWishlist");
            self.checkLogin();
            self.toCartAndWishlistFromCms();
            self.isLoading = false;
            self.redirection();
          }
        }
      } else {
        self.isLoading = false;
        // Nprogress.done();
      }
    },
    async toCartAndWishlistFromCms() {
      var cmsRequestFunctions = gettingRestClientObject();
      var self = this;
      var user = localStorage.getItem("embryo");
      if (user) {
        var userData = JSON.parse(user);
        var userName = userData.user_data.loginId;
        var cartItems = [];
        var filterValue = "type='Cart' AND keyword1='" + userName + "'";
        var allData = await cmsRequestFunctions.getDbDataTableValue(
          filterValue,
          "date1"
        );
        if (
          allData != undefined &&
          allData.data != undefined &&
          allData.status == 200
        ) {
          cartItems = allData.data.data;
          cartItems.forEach((element) => {
            const cartItem = self.products.find(
              (item) => item.Product_Code === element.keyword2
            );
            if (cartItem) {
              const product = cartItem;
              this.$store.dispatch("toCart", product);
            }
          });
        } else {
          console.log("error:", allData);
        }

        var wishlistItems = [];
        var filterValue2 = "type='WishList' AND keyword1='" + userName + "'";
        var allData2 = await cmsRequestFunctions.getDbDataTableValue(
          filterValue2,
          "date1"
        );
        if (
          allData2 != undefined &&
          allData2.data != undefined &&
          allData2.status == 200
        ) {
          wishlistItems = allData2.data.data;
          wishlistItems.forEach((element) => {
            const items = self.products.find(
              (item) => item.Product_Code === element.keyword2
            );
            if (items) {
              const product = items;
              this.$store.dispatch("toWishlist", product);
            }
          });
        } else {
          console.log("error:", allData2);
        }
      }
    },
    redirection() {
      var user = localStorage.getItem("embryo");
      var userData = JSON.parse(user);
      if (userData) {
        var useDetails = userData.user_data;
        if (!useDetails.isPhoneNumberVerified) {
          this.$router.push({ path: "/account/profile" });
        }
      }
    },
    logout() {
      localStorage.removeItem("embryo");
      localStorage.removeItem("access_token");
      this.$store.dispatch("destroyCartAndWishlist");
      window.location.href = "/home";
    },
    checkLogin() {
      var self = this;
      var user = localStorage.getItem("embryo");
      if (user != null && user != undefined && user != "") {
        var userDataTemp = JSON.parse(user);
        self.userData = userDataTemp.user_data;
        // self.isLoading = false;
        Nprogress.done();
      } else {
        self.userData = {};
        // self.isLoading = false;
        Nprogress.done();
      }
    },
  },
};
</script>